import axios from 'axios';
import React, { useEffect, useState } from 'react'
import Meta from './layout/Meta';
import moment from 'moment';
import helpers from '../helper';
import Loadingpage from '../loader/Blog';
import { Link, useParams } from 'react-router-dom';
import Datanotfound from './layout/Datanotfound';


export default function Blog() {
    const params = useParams();
    const [blogs, setBlogs] = useState([]);
    const [pageloader, setPageloader] = useState(false);
    const [pagedata, setPagedata] = useState();

    useEffect(() => {
        setPageloader(true);
        async function fetchData() {
            await axios.get(process.env.REACT_APP_API + 'api/blogcategory?category=' + params.alias)
            .then((response) => {
                setPagedata(response.data.result);
                setPageloader(false);
                
            });
        }
        fetchData();
    }, [params]);

    useEffect(() => {
        const fetchData2 = async () => {
            await axios.get(process.env.REACT_APP_API + 'api/blogs?category=' + params.alias).then((response) => {
                setBlogs(response.data.result.data);
            });
        }
        fetchData2();
    },[params]);
    

    return (
        <>
            <Meta id={6} />
            <main>
                <section className="InnerHead bgthm2">
                    <img loading="lazy" src={require("../assets/img/img-bg.svg").default} alt="Blog" className="imgbg" width="1600" height="453" />
                    <div className="container">
                        <div className="row justify-content-center">
                          {
                            pagedata ? 

                          
                            <div className="col-md-8 text-center">
                                <h1 className="fw-normal m-0 text-white">{pagedata.title}</h1>
                                <ol className="breadcrumb m-0 justify-content-center">
                                    <li className="breadcrumb-item"><Link to="/"><img src={require("../assets/img/home.svg").default} width="14" height="14" alt="Home" /></Link></li>
                                    <li className="breadcrumb-item"><Link to="/blogs">Blogs</Link></li>
                                    <li className="breadcrumb-item"><span aria-current="page">Blog Categories</span></li>
                                </ol>
                            </div>
                            :""
                          }
                        </div>
                    </div>
                </section>
                <section className="Sec4">
                    {
                        pageloader ?
                            <Loadingpage />
                            :
                            <div className="container">
                                
                                {
                                    blogs.length > 0 ?
                                        <div className="row blogbox">
                                            {
                                                blogs.map((blog, b) =>
                                                    <div key={b} className="col-md-4 col-sm-6 mb-4">
                                                        <Link to={"/blog/"+blog.alias} className="card BlogBlock CarBlock">
                                                            <div className="card-header">
                                                                {
                                                                    helpers.helpers1(blog.image) ?
                                                                        <picture className="img">
                                                                            <img loading="lazy" src={process.env.REACT_APP_IMAGE + 'uploads/blog/' + blog.image} alt={blog.title} width="121" height="131" />
                                                                        </picture>
                                                                        :
                                                                        <picture className="img">
                                                                            <source srcSet={process.env.REACT_APP_IMAGE + 'uploads/blog/webp/' + blog.image + '.webp'} type="image/webp" />
                                                                            <source srcSet={process.env.REACT_APP_IMAGE + 'uploads/blog/avif/' + blog.image + '.avif'} type="image/avif" />
                                                                            <img loading="lazy" src={process.env.REACT_APP_IMAGE + 'uploads/blog/jpg/' + blog.image + '.jpg'} alt={blog.title} width="121" height="131" />
                                                                        </picture>
                                                                }
                                                            </div>
                                                            <div className="card-body px-0 mt-1 text-center">
                                                                <span className="thm small">{moment(blog.post_date).format('DD MMMM YYYY')}</span>
                                                                <h3 className="h5 mt-2 fw-semibold">{blog.title}</h3>
                                                            </div>
                                                        </Link>
                                                    </div>
                                                )
                                            }

                                        </div>
                                        :
                                        blogs.length === 0 ? <Datanotfound/> : ''
                                        
                                }

                            </div>
                    }
                </section>
            </main>
        </>
    )
}
